<div class="root-container">
  <div class="content">
    <div class="section">
      <img class="logo" src="assets/images/common/company_logo.png">
      @if(!showLogin){
        <div class="form-container">
          <div class="login-banner">
            <div class="title">Login to continue</div>
            <div class="message">Browse our product catalogue and request for quotations!.</div>
          </div>
          <div class="d-flex flex-column align-content-end">
            <button (click)="enableSignIn(true)" class="jumbo-button login" >Sign In</button>
            <button (click)="onRegister()" class="jumbo-button register">Register</button>
          </div>
        </div>

      }
      @if (showLogin){
        <div class="form-container">
          @if (isLoading) {
            <spinner class="text-center"/>
          }
          <form [formGroup]="form">
            @if (!isLoading && currentField == 'email' ) {
              <label>
                Please enter your email address:
                <input type="text"
                  maxlength="100"
                  class="form-control"
                  formControlName="email"
                  (keydown.enter)="onSubmit()"
                  placeholder="Enter Email Address">
                </label>
              }
              @if (!isLoading && currentField == 'password' ) {
                <label class="password-label">
                  Please enter your password:
                  <input [type]="showPassword? 'text' : 'password' "
                    maxlength="20"
                    class="form-control"
                    (keydown.enter)="onSubmit()"
                    formControlName="password"
                    placeholder="Password">
                    <password-toggle (click)="showPassword=!showPassword" />
                  </label>
                  <div class="change-account" (click)="changeAccount()"> Change Account ({{ form.controls['email'].value }})  </div>
                }
              </form>
              @if (error_message) {
                <div class="input-errors">{{ error_message }}</div>
              }
              @if (!isLoading) {
                <button
                  class="jumbo-button"
                  [class]=" isFormControlValid(currentField)? 'login':'disabled' "
                (click)="onSubmit()">Continue</button>
              }
            </div>

          }
        </div>
        <div class="section hero-section">
          <img class="hero-image" src="assets/images/auth/man-cloud.jpg" alt="">
        </div>
      </div>
    </div>
